<script setup>
import { useI18n } from 'vue-i18n';
import { useStore } from 'dashboard/composables/store';
import { useAlert } from 'dashboard/composables';

import InfojobsCampaignForm from './InfojobsCampaignForm.vue';

const emit = defineEmits(['close']);
const { t } = useI18n();
const store = useStore();

const handleSubmit = async campaignDetails => {
  try {
    await store.dispatch('campaigns/create', campaignDetails);
    useAlert(t('CAMPAIGN.INFOJOBS.CREATE.FORM.API.SUCCESS_MESSAGE'));
    emit('close');
  } catch (error) {
    useAlert(
      error?.response?.data?.error ||
        t('CAMPAIGN.INFOJOBS.CREATE.FORM.API.ERROR_MESSAGE')
    );
  }
};
</script>

<template>
  <div
    class="w-[calc(100vw-2rem)] sm:w-[25rem] z-50 min-w-0 absolute top-10 ltr:right-0 rtl:left-0 bg-n-alpha-3 backdrop-blur-[100px] rounded-xl border border-n-weak shadow-md max-h-[80vh] overflow-y-auto"
  >
    <div class="p-6 flex flex-col gap-6">
      <h3 class="text-base font-medium text-n-slate-12">
        {{ t('CAMPAIGN.INFOJOBS.CREATE.TITLE') }}
      </h3>
      <InfojobsCampaignForm @submit="handleSubmit" @cancel="emit('close')" />
    </div>
  </div>
</template>
